__turbopack_context__.v({
  "divider": "styles-module__9q77NW__divider",
});
